module.exports = __webpack_public_path__ + "img/goal.c2d34b43.png";